import React from 'react'
import { mount } from 'enzyme'
import { SmartRates } from '../SmartRates'
import SmartRateDisplay from '../SmartRateDisplay'
import Loader from '../../common/Loader'
import AlertTriangle from '../../common/icons/AlertTriangle'

describe('<SmartRates />', () => {
  let wrapper, instance, props
  beforeEach(() => {
    const product = {
      finalDecision: '{}'
    }
    props = {
      loanIds: [1, 2, 3],
      data: {
        loading: false,
        error: undefined,
        loans: [
          { smartRate: 0, lastPredictionDataPermutation: null,              businesses: [{ name: 'business 1' }], needsRedecision: false, rid: 1, product },
          { smartRate: 3, lastPredictionDataPermutation: 'credit',          businesses: [{ name: 'business 2' }], needsRedecision: true,  rid: 2, product },
          { smartRate: 5, lastPredictionDataPermutation: 'credit_business', businesses: [{ name: 'business 3' }], needsRedecision: false, rid: 3, product }
        ],
        latestPredictionsForLoans: []
      }
    }
    for (const loan of props.data.loans) { // Setup DOM elements for portal rendering
      const element = global.document.createElement('div')
      element.setAttribute('id', `${loan.rid}-smart-rate-container`)
      global.document.querySelector('body').appendChild(element)
    }
    wrapper = mount(<SmartRates {...props} />)
    instance = wrapper.instance()
  })

  afterEach(() => {
    wrapper.unmount()
  })

  describe('#render', () => {

    describe('when loading is true', () => {
      beforeEach(() => {
        wrapper.setProps({ data: { loading: true } })
      })
      it('should return a <Loader />', () => {
        expect(wrapper.find(Loader)).toHaveLength(1)
      })
    })

    describe('when there is an error', () => {
      beforeEach(() => {
        wrapper.setProps({ data: { error: {} } })
      })
      it('should render an <AlertTriangle /> for each loan', () => {
        expect(wrapper.find(AlertTriangle)).toHaveLength(props.data.loans.length)
      })
    })

    describe('when there is no error and it is not loading', () => {
      it('should render a <SmartRateDisplay /> for each loan', () => {
        expect(wrapper.find(SmartRateDisplay)).toHaveLength(props.data.loans.length)
      })
    })

    describe('when DOM element is not present', () => {
      beforeEach(() => {
        wrapper.setProps({ loanIds: [1,2,3,4] })
      })
      it('should return a <Loader />', () => {
        expect(wrapper.find(SmartRateDisplay)).toHaveLength(props.data.loans.length)
      })
    })
  })

  describe('#unhideLoansTable', () => {
    let loansTable
    beforeEach(() => {
      loansTable = global.document.createElement('div')
      loansTable.setAttribute('id', 'loans-table')
      loansTable.style.display = 'none'
      global.document.querySelector('body').appendChild(loansTable)
    })
    it('should change the loans table\'s display from "none" to "table"', () => {
      instance.unhideLoansTable()
      expect(loansTable.style.display).toBe('table')
    })
  })
  describe('#componentDidCatch', () => {
    it('should call #unhideLoansTable()', () => {
      instance.unhideLoansTable = jest.fn()
      instance.componentDidCatch()
      expect(instance.unhideLoansTable).toHaveBeenCalledTimes(1)
    })
  })
})
